import { createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import * as processTypeFormTypes from './processTypeFormTypes';

export const onProcessTypeRefSelected = createAction(processTypeFormTypes.PROCESS_TYPE_REF_SELECTED, Code => ({
  Code,
}));
export const onAddButtonClicked = createAction(processTypeFormTypes.ADD_BUTTON_CLICKED);
export const submitProcessTypeForm = createFormAction(processTypeFormTypes.SUBMIT_PROCESSTYPE_FORM);
